import { render, staticRenderFns } from "./indexOld.vue?vue&type=template&id=26946426&scoped=true"
import script from "./indexOld.vue?vue&type=script&lang=js"
export * from "./indexOld.vue?vue&type=script&lang=js"
import style0 from "./indexOld.vue?vue&type=style&index=0&id=26946426&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26946426",
  null
  
)

export default component.exports